import type { TagDto } from './tag'
import type { PostType } from '@gunslop/ui'

export type { PostType }

export interface PostCommentDto {
  id: number;
  body: string;
  authorId?: string | null;
  authorUsername: string;
  authorDisplayName: string;
  authorImage: string | null;
  authorAmmoScore: number;
  authorAmmoTier: string;
  parentCommentId: number | null;
  createdAt: string;
  voteScore: number;
  currentUserVote: number | null;
  isHidden?: boolean;
}

export interface Post {
  id: string;
  title: string;
  slug: string;
  body: string;
  excerpt: string;
  coverImageUrl: string | null;
  /** Gallery main image for list cards (from ContentPhotos). */
  mainPhotoUrl?: string | null;
  /** Post author user id (Identity); used server-side; safe to ignore on client. */
  authorId?: string | null;
  authorUsername: string;
  authorDisplayName: string;
  authorImage: string | null;
  authorAmmoScore: number;
  authorAmmoTier: string;
  createdAt: string;
  updatedAt: string;
  type: PostType;
  firearmModelId: string | null;
  firearmModelName: string | null;
  partId: string | null;
  partName: string | null;
  ammoProductId?: string | null;
  ammoProductName?: string | null;
  rating: number | null;
  pros?: string | null;
  cons?: string | null;
  verdict?: string | null;
  tags: TagDto[];
  voteScore: number;
  currentUserVote: number | null;
  comments: PostCommentDto[];
}

export interface PostFormValues {
  id?: string;
  title: string;
  body: string;
  excerpt: string;
  coverImageUrl: string;
  type?: PostType;
  firearmModelId?: string | null;
  partId?: string | null;
  ammoProductId?: string | null;
  rating?: number | null;
  pros?: string | null;
  cons?: string | null;
  verdict?: string | null;
  tags?: TagDto[];
}

export class PostFormValues implements PostFormValues {
  id?: string = undefined
  title: string = ''
  body: string = ''
  excerpt: string = ''
  coverImageUrl: string = ''
  type?: PostType = 0
  firearmModelId?: string | null = null
  partId?: string | null = null
  ammoProductId?: string | null = null
  rating?: number | null = null
  pros?: string | null = null
  cons?: string | null = null
  verdict?: string | null = null
  tags?: TagDto[] = []

  constructor (post?: PostFormValues | Post) {
    if (post) {
      this.id = post.id
      this.title = post.title
      this.body = post.body
      this.excerpt = post.excerpt ?? ''
      this.coverImageUrl = (post as Post).coverImageUrl ?? (post as PostFormValues).coverImageUrl ?? ''
      this.type = (post as Post).type ?? (post as PostFormValues).type ?? 0
      this.firearmModelId = (post as Post).firearmModelId ?? (post as PostFormValues).firearmModelId ?? null
      this.partId = (post as Post).partId ?? (post as PostFormValues).partId ?? null
      this.ammoProductId = (post as Post).ammoProductId ?? (post as PostFormValues).ammoProductId ?? null
      this.rating = (post as Post).rating ?? (post as PostFormValues).rating ?? null
      this.pros = (post as Post).pros ?? (post as PostFormValues).pros ?? null
      this.cons = (post as Post).cons ?? (post as PostFormValues).cons ?? null
      this.verdict = (post as Post).verdict ?? (post as PostFormValues).verdict ?? null
      this.tags = (post as Post).tags ?? (post as PostFormValues).tags ?? []
    }
  }
}
